import { render, staticRenderFns } from "./InfoMessageBalloon.vue?vue&type=template&id=78d88154&scoped=true&"
import script from "./InfoMessageBalloon.vue?vue&type=script&lang=js&"
export * from "./InfoMessageBalloon.vue?vue&type=script&lang=js&"
import style0 from "./InfoMessageBalloon.vue?vue&type=style&index=0&id=78d88154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d88154",
  null
  
)

export default component.exports